import React, { useEffect, useState } from 'react';
import './ChargingLocatorPanel.scss';
import ChargingStationPanel from '../ChargingStationPanel/ChargingStationPanel';
import { useMediaQuery } from 'react-responsive';
import ZipcodePanel from '../ZipcodePanel/ZipcodePanel';
import {
  IChargingStation,
  IEVChargingPageContent,
} from 'interfaces/chargingLocator';
import useZipcode from 'hooks/useZipcode';

interface IChargingLocatorPanel {
  stations: IChargingStation[];
  selectedStation?: IChargingStation;
  handleStationChange: (x: IChargingStation | undefined) => void;
  pageContent: IEVChargingPageContent;
  disable: boolean;
  panelUpdate: boolean;
}

const ChargingLocatorPanel = ({
  stations,
  selectedStation,
  handleStationChange,
  pageContent,
  disable,
  panelUpdate,
}: IChargingLocatorPanel): JSX.Element => {
  const [stationPanelOpen, setStationPanelOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const labels = pageContent.labels;
  const { zipcode } = useZipcode();

  useEffect(() => {
    if (selectedStation) {
      setStationPanelOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStation]);

  useEffect(() => {
    closePanel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panelUpdate]);

  useEffect(() => {
    closePanel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipcode]);

  const closePanel = () => {
    setStationPanelOpen(false);
    handleStationChange(undefined);
  };

  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const typeVariation = isHonda
    ? 'charging-locator-panel-honda'
    : 'charging-locator-panel';

  return (
    <>
      <div className={`${typeVariation}`}>
        <ZipcodePanel
          stationsAmount={stations.length}
          placeholder={labels.placeholder}
          disable={disable}
        />
        {!isMobile && stationPanelOpen && selectedStation && (
          <ChargingStationPanel
            stationData={selectedStation}
            labels={{
              acuraEVApp: labels.acuraEVApp,
              details: labels.details,
              amenities: labels.amenities,
              connectors: labels.connectors,
              resultDisclaimer: labels.resultDisclaimer,
            }}
            onClose={closePanel}
          />
        )}
      </div>
      {isMobile && stationPanelOpen && selectedStation && (
        <ChargingStationPanel
          stationData={selectedStation}
          labels={{
            acuraEVApp: labels.acuraEVApp,
            details: labels.details,
            amenities: labels.amenities,
            connectors: labels.connectors,
            resultDisclaimer: labels.resultDisclaimer,
          }}
          onClose={closePanel}
        />
      )}
    </>
  );
};

export default ChargingLocatorPanel;
